import Vue from "vue";
import Router from "vue-router";
import store from "./store.js";
Vue.use(Router);

export default new Router({
  mode: "history",
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    // {
    //   path: "/",
    //   name: "placeholder",
    //   component: () =>
    //     import(/* webpackChunkName: "Placeholder" */ "./views/Placeholder.vue"),
    // },
    {
      path: "/",
      name: "home",
      component: () =>
        import(/* webpackChunkName: "Home" */ "./views/Home.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.home) {
          store.dispatch("loadPage", "home").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/about",
      name: "about",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.about) {
          store.dispatch("loadPage", "about").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/imprint",
      name: "imprint",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.imprint) {
          store.dispatch("loadPage", "imprint").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/privacy",
      name: "privacy",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.privacy) {
          store.dispatch("loadPage", "privacy").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/returns",
      name: "returns",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.returns) {
          store.dispatch("loadPage", "returns").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/returnform",
      name: "returnform",
      component: () =>
        import(/* webpackChunkName: "ReturnForm" */ "./views/ReturnForm.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.returnform) {
          store.dispatch("loadPage", "returnform").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/success",
      name: "success",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.success) {
          store.dispatch("loadPage", "success").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/cancel",
      name: "cancel",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.cancel) {
          store.dispatch("loadPage", "cancel").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/sizing",
      name: "sizing",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.sizing) {
          store.dispatch("loadPage", "sizing").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/care",
      name: "care",
      component: () =>
        import(/* webpackChunkName: "Default" */ "./views/Default.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.care) {
          store.dispatch("loadPage", "care").then(next);
        } else {
          next();
        }
      },
    },
    {
      path: "/cart",
      name: "cart",
      component: () =>
        import(/* webpackChunkName: "Cart" */ "./views/Cart.vue"),
      beforeEnter: (to, from, next) => {
        if (!store.state.pages.cart) {
          store.dispatch("loadPage", "cart").then(next);
        } else {
          next();
        }
      },
    },
    // {
    //   path: "/projects/:id",
    //   name: "project",
    //   props: true,
    //   component: () =>
    //     import(/* webpackChunkName: "Project" */ "./views/Project.vue"),
    //   beforeEnter: (to, from, next) => {
    //     store.dispatch("loadProject", to.params.id).then(next);
    //   }
    // },
    {
      path: "*",
      redirect: "/",
    },
  ],
});
